import { BoilerAdapterProtocol } from './protocol';
import { OpenThermFaultFlag, OpenThermStatusFlag, OpenThermVariableName, } from 'openTherm';
import { get_z3k_object_state } from '../../object/z3k-object';
import { removeNulls, ThermometerState } from 'utils';
import { arrayGetSet, createAccessors } from 'z3k-parser/lib/accessories';
import { BuiltInSerial } from 'z3k-parser/model/device-spec/built-in-serial';
import { accessoriesVersionWithLoaderRegExp } from 'z3k-parser/model/z3k-config/accessoires-version';
export const BoilerAdapterStateStatusRu = {
    no_adapter_connection: 'Нет подключения адаптера',
    no_boiler_connection: 'Нет подключения к котлу',
    event_connection_lost: 'Событие: соединение потеряно',
    boiler_fail: 'Ошибка котла',
    event_boiler_fail: 'Событие: отказ котла',
    no_valid_params: 'Параметры неверны',
};
export var BoilerAdapter;
(function (BoilerAdapter) {
    BoilerAdapter.TypeOptions = [
        { text: 'Arderia', value: BoilerAdapterProtocol.ARDERIA },
        { text: 'BSB', value: BoilerAdapterProtocol.BSB },
        { text: 'Daesung Class A', value: BoilerAdapterProtocol.DAESUNG_CLASS_A },
        {
            text: 'Daesung Class A MAX 50 PROT',
            value: BoilerAdapterProtocol.DAESUNG_CLASS_A_MAX_50_PROT,
        },
        { text: 'Daesung Class E', value: BoilerAdapterProtocol.DAESUNG_CLASS_E },
        { text: 'E-Bus/Ariston/Wolf', value: BoilerAdapterProtocol.EBUS },
        { text: 'EMS+', value: BoilerAdapterProtocol.EMS_PLUS },
        { text: 'Kiturami', value: BoilerAdapterProtocol.KITURAMI },
        { text: 'Modbus Ирбис', value: BoilerAdapterProtocol.MODBUS_IRBIS },
        { text: 'Modbus Лемакс', value: BoilerAdapterProtocol.MODBUS_LEMAX },
        { text: 'Modbus Rossen', value: BoilerAdapterProtocol.MODBUS_ROSSEN },
        { text: 'Navien', value: BoilerAdapterProtocol.NAVIEN },
        { text: 'OpenTherm', value: BoilerAdapterProtocol.OPENTHERM },
        { text: 'Rinnai BR-R', value: BoilerAdapterProtocol.RINNAI_BR_R },
        { text: 'Rinnai BR-K', value: BoilerAdapterProtocol.RINNAI_BR_K },
        { text: 'Rinnai BR-U', value: BoilerAdapterProtocol.RINNAI_BR_U },
        { text: 'Автоопределение', value: BoilerAdapterProtocol.AUTO },
    ];
    let Flags;
    (function (Flags) {
        Flags[Flags["WATER_TEMPERATURE_LOGGED"] = 1] = "WATER_TEMPERATURE_LOGGED";
        Flags[Flags["DHW_TEMPERATURE_LOGGED"] = 2] = "DHW_TEMPERATURE_LOGGED";
        Flags[Flags["RETURN_TEMPERATURE_LOGGED"] = 4] = "RETURN_TEMPERATURE_LOGGED";
        Flags[Flags["OUTSIDE_TEMPERATURE_LOGGED"] = 8] = "OUTSIDE_TEMPERATURE_LOGGED";
        Flags[Flags["MODULATION_LEVEL_LOGGED"] = 16] = "MODULATION_LEVEL_LOGGED";
        Flags[Flags["WATER_PRESSURE_LOGGED"] = 32] = "WATER_PRESSURE_LOGGED";
        Flags[Flags["DHW_FLOW_RATE_LOGGED"] = 64] = "DHW_FLOW_RATE_LOGGED";
        Flags[Flags["IS_OUTSIDE"] = 128] = "IS_OUTSIDE";
        Flags[Flags["SECOND_CHANNEL"] = 256] = "SECOND_CHANNEL";
        Flags[Flags["EXTERNAL_PANEL"] = 512] = "EXTERNAL_PANEL";
        Flags[Flags["IS_DISABLED"] = 1024] = "IS_DISABLED";
        Flags[Flags["IS_POWER_CTRL_FLAG"] = 2048] = "IS_POWER_CTRL_FLAG";
        Flags[Flags["IS_OUTSIDE_RESERVE"] = 4096] = "IS_OUTSIDE_RESERVE";
    })(Flags = BoilerAdapter.Flags || (BoilerAdapter.Flags = {}));
    BoilerAdapter.ALL_NAVIEN_PARAMS = [
        Flags.WATER_TEMPERATURE_LOGGED,
        Flags.DHW_TEMPERATURE_LOGGED,
    ];
    BoilerAdapter.ALL_KITURAMI_PARAMS = BoilerAdapter.ALL_NAVIEN_PARAMS;
    BoilerAdapter.ALL_EBUS_PARAMS = [
        ...BoilerAdapter.ALL_NAVIEN_PARAMS,
        Flags.RETURN_TEMPERATURE_LOGGED,
        Flags.OUTSIDE_TEMPERATURE_LOGGED,
        Flags.MODULATION_LEVEL_LOGGED,
        Flags.WATER_PRESSURE_LOGGED,
    ];
    BoilerAdapter.ALL_OPENTHERM_PARAMS = [
        ...BoilerAdapter.ALL_EBUS_PARAMS,
        Flags.DHW_FLOW_RATE_LOGGED,
    ];
    BoilerAdapter.ALL_DAESUNG_CLASS_E_PARAMS = BoilerAdapter.ALL_OPENTHERM_PARAMS;
    BoilerAdapter.ALL_DAESUNG_CLASS_A_PARAMS = BoilerAdapter.ALL_OPENTHERM_PARAMS;
    BoilerAdapter.ALL_RINNAI_PARAMS = [Flags.WATER_TEMPERATURE_LOGGED];
    BoilerAdapter.ALL_BSB_PARAMS = BoilerAdapter.ALL_OPENTHERM_PARAMS;
    BoilerAdapter.ALL_EMS_PLUS_PARAMS = BoilerAdapter.ALL_OPENTHERM_PARAMS;
    BoilerAdapter.ALL_DAESUNG_CLASS_A_MAX_50_PROT_PARAMS = BoilerAdapter.ALL_OPENTHERM_PARAMS;
    BoilerAdapter.ALL_ARDERIA_PARAMS = [
        Flags.WATER_TEMPERATURE_LOGGED,
        Flags.DHW_TEMPERATURE_LOGGED,
        Flags.MODULATION_LEVEL_LOGGED,
    ];
    BoilerAdapter.ALL_MODBUS_IRBIS_PARAMS = [
        Flags.WATER_TEMPERATURE_LOGGED,
        Flags.DHW_TEMPERATURE_LOGGED,
        Flags.WATER_PRESSURE_LOGGED,
    ];
    BoilerAdapter.ALL_MODBUS_LEMAX_PARAMS = [
        Flags.WATER_TEMPERATURE_LOGGED,
        Flags.DHW_TEMPERATURE_LOGGED,
        Flags.DHW_FLOW_RATE_LOGGED,
        Flags.WATER_PRESSURE_LOGGED,
        Flags.MODULATION_LEVEL_LOGGED,
    ];
    BoilerAdapter.ALL_MODBUS_ROSSEN_PARAMS = [
        Flags.WATER_TEMPERATURE_LOGGED,
        Flags.OUTSIDE_TEMPERATURE_LOGGED,
        Flags.MODULATION_LEVEL_LOGGED,
    ];
    function getNameForIO(ba) {
        let text = 'АЦШ ';
        if (ba.serial?.builtIn) {
            text += 'встроенный ';
        }
        else {
            text += 'внешний ';
        }
        let count = ba.slot + 1;
        if (ba.serial?.value === BuiltInSerial.zero) {
            count = 1;
        }
        if (ba.serial?.value === BuiltInSerial.first) {
            count = 2;
        }
        if (ba.serial?.value === BuiltInSerial.second) {
            count = 3;
        }
        text += '№' + count;
        return text;
    }
    BoilerAdapter.getNameForIO = getNameForIO;
    function allParamsMaskForType(adapter) {
        if (adapter.serial.builtIn && adapter.serial.value === BuiltInSerial.second) {
            return BoilerAdapter.ALL_EBUS_PARAMS;
        }
        switch (adapter.type) {
            case BoilerAdapterProtocol.OPENTHERM:
                return BoilerAdapter.ALL_OPENTHERM_PARAMS;
            case BoilerAdapterProtocol.EBUS:
                return BoilerAdapter.ALL_EBUS_PARAMS;
            case BoilerAdapterProtocol.NAVIEN:
                return BoilerAdapter.ALL_NAVIEN_PARAMS;
            case BoilerAdapterProtocol.BSB:
                return BoilerAdapter.ALL_BSB_PARAMS;
            case BoilerAdapterProtocol.DAESUNG_CLASS_A:
                return BoilerAdapter.ALL_DAESUNG_CLASS_A_PARAMS;
            case BoilerAdapterProtocol.DAESUNG_CLASS_E:
                return BoilerAdapter.ALL_DAESUNG_CLASS_E_PARAMS;
            case BoilerAdapterProtocol.RINNAI_BR_R:
                return BoilerAdapter.ALL_RINNAI_PARAMS;
            case BoilerAdapterProtocol.RINNAI_BR_U:
                return BoilerAdapter.ALL_RINNAI_PARAMS;
            case BoilerAdapterProtocol.RINNAI_BR_K:
                return BoilerAdapter.ALL_RINNAI_PARAMS;
            case BoilerAdapterProtocol.ARDERIA:
                return BoilerAdapter.ALL_ARDERIA_PARAMS;
            case BoilerAdapterProtocol.EMS_PLUS:
                return BoilerAdapter.ALL_EMS_PLUS_PARAMS;
            case BoilerAdapterProtocol.DAESUNG_CLASS_A_MAX_50_PROT:
                return BoilerAdapter.ALL_DAESUNG_CLASS_A_MAX_50_PROT_PARAMS;
            case BoilerAdapterProtocol.MODBUS_IRBIS:
                return BoilerAdapter.ALL_MODBUS_IRBIS_PARAMS;
            case BoilerAdapterProtocol.MODBUS_LEMAX:
                return BoilerAdapter.ALL_MODBUS_LEMAX_PARAMS;
            case BoilerAdapterProtocol.MODBUS_ROSSEN:
                return BoilerAdapter.ALL_MODBUS_ROSSEN_PARAMS;
            case BoilerAdapterProtocol.KITURAMI:
                return BoilerAdapter.ALL_KITURAMI_PARAMS;
            default:
                return BoilerAdapter.ALL_OPENTHERM_PARAMS;
        }
    }
    BoilerAdapter.allParamsMaskForType = allParamsMaskForType;
    BoilerAdapter.loggedParameterOTVarName = new Map([
        [Flags.WATER_TEMPERATURE_LOGGED, OpenThermVariableName.bt],
        [Flags.DHW_TEMPERATURE_LOGGED, OpenThermVariableName.dt],
        [Flags.RETURN_TEMPERATURE_LOGGED, OpenThermVariableName.rwt],
        [Flags.OUTSIDE_TEMPERATURE_LOGGED, OpenThermVariableName.ot],
        [Flags.MODULATION_LEVEL_LOGGED, OpenThermVariableName.rml],
        [Flags.WATER_PRESSURE_LOGGED, OpenThermVariableName.wp],
        [Flags.DHW_FLOW_RATE_LOGGED, OpenThermVariableName.fr],
    ]);
    function isLoggedParameter(ba, flag) {
        return (ba.logged_parameter_register & flag) != 0;
    }
    BoilerAdapter.isLoggedParameter = isLoggedParameter;
    function getLoggedParameters(ba) {
        // Сначала мы узнаём все возможные флаги для этого ТИПА АЦШ
        const type_mask = BoilerAdapter.allParamsMaskForType(ba);
        // Теперь смотрим на то, что выбрал пользователь
        return new Map(type_mask.map((parameter) => [parameter, isLoggedParameter(ba, parameter)]));
    }
    BoilerAdapter.getLoggedParameters = getLoggedParameters;
    /**
     * @function
     * Учитываем конфигурацию АЦШ. Получаем флаги, которые нужно игнорировать
     * @param ba - кусок АЦШ
     * @return set из OT_VarName, которые не нужно просматривать
     */
    function notAvailableOTParameters(ba) {
        return new Set(removeNulls([...getLoggedParameters(ba)].map(([parameter, is_enabled]) => !is_enabled ? BoilerAdapter.loggedParameterOTVarName.get(parameter) : null)));
    }
    BoilerAdapter.notAvailableOTParameters = notAvailableOTParameters;
    /**
     * @function
     * Учитываем конфигурацию АЦШ.
     * Получаем флаги, которые нам нужны
     * @param ba - кусок АЦШ
     * @return set из OT_VarName, которые не нужно просматривать
     */
    function availableOTParameters(ba) {
        return new Set(removeNulls([...getLoggedParameters(ba)].map(([parameter, is_enabled]) => is_enabled ? BoilerAdapter.loggedParameterOTVarName.get(parameter) : null)));
    }
    BoilerAdapter.availableOTParameters = availableOTParameters;
    BoilerAdapter.OTTemps = [
        OpenThermVariableName.bt,
        OpenThermVariableName.dt,
        OpenThermVariableName.rwt,
        OpenThermVariableName.ot,
        OpenThermVariableName.rt,
    ];
    BoilerAdapter.OTValueTypeTranslation = new Map([
        [OpenThermVariableName.bt, 't° ТН'],
        [OpenThermVariableName.dt, 't° ГВС'],
        [OpenThermVariableName.rwt, 't° обратного потока'],
        [OpenThermVariableName.ot, 't° вне дома'],
        [OpenThermVariableName.rt, 't° комнатная'],
    ]);
    function getAvailableOTTemperatures(ba) {
        const all_ot_available_params = availableOTParameters(ba);
        const available_ot_temps = BoilerAdapter.OTTemps.filter((temp_param) => all_ot_available_params.has(temp_param));
        return available_ot_temps.map((ot_name) => ({
            id: ba.id,
            ot_name,
            name: BoilerAdapter.OTValueTypeTranslation.get(ot_name) ?? '',
            upper_threshold: ot_name == OpenThermVariableName.ot ? 40 : null,
            lower_threshold: ot_name == OpenThermVariableName.ot ? -40 : null,
        }));
    }
    BoilerAdapter.getAvailableOTTemperatures = getAvailableOTTemperatures;
    BoilerAdapter.OTParams = [
        OpenThermVariableName.rml,
        OpenThermVariableName.wp,
        OpenThermVariableName.fr,
    ];
    BoilerAdapter.OTParamsTranslation = new Map([
        [OpenThermVariableName.rml, 'Модуляция'],
        [OpenThermVariableName.wp, 'Давление ТН'],
        [OpenThermVariableName.fr, 'Скорость потока ГВС'],
    ]);
    function getAvailableOTParams(ba) {
        const all_ot_available_params = availableOTParameters(ba);
        const available_ot_temps = BoilerAdapter.OTParams.filter((temp_param) => all_ot_available_params.has(temp_param));
        // const max_modulation = ot_state?.[OpenThermVariableName.mrml] ?? 100;
        return available_ot_temps.map((ot_name) => ({
            id: ba.id,
            ot_name,
            // value: (ot_state?.[ot_name] as number) ?? null,
            value: null,
            name: ba.name + ' ' + BoilerAdapter.OTParamsTranslation.get(ot_name) ?? '',
            // upper_threshold: ot_name == OpenThermVariableName.rml ? max_modulation : 3,
            upper_threshold: 3,
            lower_threshold: 0,
        }));
    }
    BoilerAdapter.getAvailableOTParams = getAvailableOTParams;
    function onChangeBuiltIn(ba, check) {
        return {
            ...ba,
            serial: {
                builtIn: check,
                value: ba.serial.builtIn ? ba.serial.value : BuiltInSerial.zero,
            },
        };
    }
    BoilerAdapter.onChangeBuiltIn = onChangeBuiltIn;
    function isExternalPanel(ba) {
        return (ba.logged_parameter_register & Flags.EXTERNAL_PANEL) != 0;
    }
    BoilerAdapter.isExternalPanel = isExternalPanel;
    function setExternalPanel(boilerAdapter, externalPanel) {
        return {
            ...boilerAdapter,
            logged_parameter_register: (boilerAdapter.logged_parameter_register & ~Flags.EXTERNAL_PANEL) |
                (externalPanel ? Flags.EXTERNAL_PANEL : 0),
        };
    }
    BoilerAdapter.setExternalPanel = setExternalPanel;
    function setWeather(boilerAdapter, need_weather) {
        return {
            ...boilerAdapter,
            logged_parameter_register: (boilerAdapter.logged_parameter_register & ~Flags.IS_OUTSIDE) |
                (need_weather ? Flags.IS_OUTSIDE : 0),
        };
    }
    BoilerAdapter.setWeather = setWeather;
    function isTurnOnExtPanel(ba, state) {
        return ba != null
            ? !!get_z3k_object_state(state, ba.id)?.flags?.MODE_OPENTHERM_GATEWAY_BIT
            : false;
    }
    BoilerAdapter.isTurnOnExtPanel = isTurnOnExtPanel;
    function isEnabled(boilerAdapter) {
        return (boilerAdapter.logged_parameter_register & Flags.IS_DISABLED) == 0;
    }
    BoilerAdapter.isEnabled = isEnabled;
    function setEnabled(boilerAdapter, enabled) {
        return {
            ...boilerAdapter,
            logged_parameter_register: (boilerAdapter.logged_parameter_register & ~Flags.IS_DISABLED) |
                (enabled ? 0 : Flags.IS_DISABLED),
        };
    }
    BoilerAdapter.setEnabled = setEnabled;
    function isSecondChannel(boilerAdapter) {
        return (boilerAdapter.logged_parameter_register & Flags.SECOND_CHANNEL) != 0;
    }
    BoilerAdapter.isSecondChannel = isSecondChannel;
    function setSecondChannel(boilerAdapter, isSecondChanel) {
        return {
            ...boilerAdapter,
            logged_parameter_register: (boilerAdapter.logged_parameter_register & ~Flags.SECOND_CHANNEL) |
                (isSecondChanel ? Flags.SECOND_CHANNEL : 0),
        };
    }
    BoilerAdapter.setSecondChannel = setSecondChannel;
    function isOutside(boilerAdapter) {
        return (boilerAdapter.logged_parameter_register & Flags.IS_OUTSIDE) > 0;
    }
    BoilerAdapter.isOutside = isOutside;
    function isOutsideReserve(boilerAdapter) {
        return (boilerAdapter.logged_parameter_register & Flags.IS_OUTSIDE_RESERVE) > 0;
    }
    BoilerAdapter.isOutsideReserve = isOutsideReserve;
    function getTypeOptions(device_spec) {
        if (device_spec.heating.has_heating) {
            if (device_spec.heating.ba_allow_types != null) {
                return BoilerAdapter.TypeOptions.filter(({ value }) => device_spec.heating.has_heating &&
                    device_spec.heating.ba_allow_types != null &&
                    device_spec.heating.ba_allow_types.includes(value));
            }
            if (device_spec.heating.ba_can_use_auto_detection) {
                return BoilerAdapter.TypeOptions;
            }
        }
        return BoilerAdapter.TypeOptions.filter((option) => option.value !== BoilerAdapterProtocol.AUTO);
    }
    BoilerAdapter.getTypeOptions = getTypeOptions;
    function getWorkState(ba, state) {
        if (state == null) {
            return null;
        }
        //Нахожу состояние этого адаптера
        const ba_state = get_z3k_object_state(state, ba.id);
        if (ba_state != null) {
            return ba_state.ot[OpenThermVariableName.s] ?? null;
        }
        return null;
    }
    BoilerAdapter.getWorkState = getWorkState;
    function hasError(ba, state) {
        const ba_state = get_z3k_object_state(state, ba.id);
        if (ba_state == null) {
            return true;
        }
        const { ot } = ba_state;
        if (ot == null) {
            return true;
        }
        return hasOTError(ba, ot);
    }
    BoilerAdapter.hasError = hasError;
    function getSensorErrorState(ba, state, firmware) {
        const ba_state = get_z3k_object_state(state, ba.id);
        if (ba_state == null) {
            return ThermometerState.disconnected;
        }
        const { status } = ba_state;
        if (firmware >= 378) {
            if (status?.no_adapter_connection) {
                return ThermometerState.disconnected;
            }
            if (status?.no_boiler_connection) {
                return ThermometerState.not_connected;
            }
            if (status?.event_connection_lost) {
                return ThermometerState.not_connected;
            }
            if (status?.no_valid_params) {
                return ThermometerState.malfunction;
            }
        }
        return ThermometerState.ok;
    }
    BoilerAdapter.getSensorErrorState = getSensorErrorState;
    function hasOTError(ba, state) {
        if (ba.boiler_model == 'dedietrich-naneo-s') {
            const err_in_s = (state.s ?? []).includes(OpenThermStatusFlag.f);
            const err_in_ff = (state.ff?.f ?? []).includes(OpenThermFaultFlag.sr);
            const err_in_rbp = state.rbp != null &&
                !(state.rbp[0] == 255 && state.rbp[1] == 255) &&
                !(state.rbp[0] == 0 && state.rbp[1] == 0);
            return err_in_s || err_in_ff || err_in_rbp;
        }
        return (state.s ?? []).includes(OpenThermStatusFlag.f);
    }
    BoilerAdapter.hasOTError = hasOTError;
    function shownToUser(device_spec) {
        return device_spec.show_builtin_boiler_adapter;
    }
    BoilerAdapter.shownToUser = shownToUser;
    const hardware_regex = new RegExp(/^[a-zA-z](\d*).(\w*)/);
    function getFirmwareVersion(ba) {
        const version = parseInt(ba.hardware);
        const with_loader_matches = ba.hardware.match(accessoriesVersionWithLoaderRegExp);
        if (with_loader_matches) {
            return parseInt(with_loader_matches[3]);
        }
        const matches = ba.hardware.match(hardware_regex);
        if (matches) {
            return Number(matches[1]);
        }
        if (isNaN(version)) {
            return 0;
        }
        return version;
    }
    BoilerAdapter.getFirmwareVersion = getFirmwareVersion;
    function getHardwareVersion(ba) {
        const with_loader_matches = ba.hardware.match(accessoriesVersionWithLoaderRegExp);
        if (with_loader_matches) {
            return parseInt(with_loader_matches[2]);
        }
        return -1;
    }
    BoilerAdapter.getHardwareVersion = getHardwareVersion;
    function canUpdate(ba) {
        const match = ba.hardware?.match(accessoriesVersionWithLoaderRegExp);
        if (match) {
            return match[1] == 'BL2';
        }
        return false;
    }
    BoilerAdapter.canUpdate = canUpdate;
    BoilerAdapter.default_object = {
        isManual: true,
        serial: {
            builtIn: true,
            value: '',
        },
        name: 'Адаптер котла',
        type: BoilerAdapterProtocol.OPENTHERM,
        max_modulation_level: 100,
        logged_parameter_register: 127,
        boiler_model: '',
        rol_connection_lost: [],
        rol_connection_found: [],
        slot: 0,
        position: 0,
        rol_boiler_failure: [],
        rol_boiler_restore: [],
        hardware: 'UNKNOWN',
        processor: 0,
        adapter_type: 0,
    };
    BoilerAdapter.get = createAccessors(arrayGetSet('boiler_adapters'), BoilerAdapter.default_object);
})(BoilerAdapter || (BoilerAdapter = {}));
